import React from 'react'; 
import blueIcon from '../hybridImages/BlueBulbIcon.png';
 
const BlueboxTextList = (props) => {
    const {textList} = props;

    return(
    <div className="row around-xs inputPair elementVisible">
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div className='bluebox'>
                <div style={{display:'-webkit-inline-box'}}>
                    <img src={blueIcon} alt='blue-bulb' className='upload-left-icon-size' /> 
                    <ul className='bluebox-txt-ul'>
                    {textList.map((item, idx) => (
                        <li key={idx}>{item}</li>
                    ))}
                    </ul>
                </div>
            </div>
        </div>
    </div>
    )
}

export default BlueboxTextList